import React, { useState } from "react";
import Layout from '../components/Layout';
import LateFeeManagement from '../components/billing/LateFeeManagement';
import BulkDiscountManagement from '../components/billing/BulkDiscountManagement';
import ReportingDashboard from '../components/billing/ReportingDashboard';
import ProrationManagement from '../components/billing/ProrationManagement';
import PlanTierManagement from '../components/billing/PlanTierManagement';
import "./BillingPage.css";
import { Lightning, Money, ChartBar, TrendUp, CreditCard } from '@phosphor-icons/react';

/**
 * Billing Admin Page
 * Super-admin console for platform billing: late fees, bulk discounts,
 * mid-term proration, and revenue/collection reporting across all schools.
 * Previously these components existed but were never mounted anywhere in
 * the app.
 */
const BillingAdminPage = () => {
  const [activeTab, setActiveTab] = useState("late-fees");

  const pageContent = (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Billing Administration</h1>
          <p>Manage platform subscription late fees, discounts, proration, and revenue reporting</p>
        </div>
      </div>

      <div className="tabs-container">
        <button
          className={`tab-btn ${activeTab === "late-fees" ? "active" : ""}`}
          onClick={() => setActiveTab("late-fees")}
          title="Late Fees"
        >
          <Lightning size={18} weight="fill" />
          <span className="ms-2">Late Fees</span>
        </button>
        <button
          className={`tab-btn ${activeTab === "discounts" ? "active" : ""}`}
          onClick={() => setActiveTab("discounts")}
          title="Bulk Discounts"
        >
          <Money size={18} weight="fill" />
          <span className="ms-2">Bulk Discounts</span>
        </button>
        <button
          className={`tab-btn ${activeTab === "proration" ? "active" : ""}`}
          onClick={() => setActiveTab("proration")}
          title="Proration"
        >
          <TrendUp size={18} weight="fill" />
          <span className="ms-2">Proration</span>
        </button>
        <button
          className={`tab-btn ${activeTab === "reports" ? "active" : ""}`}
          onClick={() => setActiveTab("reports")}
          title="Reporting"
        >
          <ChartBar size={18} weight="fill" />
          <span className="ms-2">Reporting</span>
        </button>
        <button
          className={`tab-btn ${activeTab === "plan-pricing" ? "active" : ""}`}
          onClick={() => setActiveTab("plan-pricing")}
          title="Plan & Pricing"
        >
          <CreditCard size={18} weight="fill" />
          <span className="ms-2">Plan & Pricing</span>
        </button>
      </div>

      <div className="page-content">
        {activeTab === "late-fees" && <LateFeeManagement />}
        {activeTab === "discounts" && <BulkDiscountManagement />}
        {activeTab === "proration" && <ProrationManagement />}
        {activeTab === "reports" && <ReportingDashboard />}
        {activeTab === "plan-pricing" && <PlanTierManagement />}
      </div>
    </div>
  );

  return <Layout>{pageContent}</Layout>;
};

export default BillingAdminPage;
